import React from 'react';
import { useTranslation } from 'react-i18next';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { LANGUAGES } from '../../i18n/i18n';

/** ES / EN toggle in the top bar. The choice is kept in localStorage by the language detector. */
const LanguageSwitcher = () => {
  const { t, i18n } = useTranslation('common');
  const current = i18n.resolvedLanguage;

  const handleChange = (_event, language) => {
    if (language && language !== current) {
      i18n.changeLanguage(language);
    }
  };

  return (
    <ToggleButtonGroup
      size="small"
      exclusive
      value={current}
      onChange={handleChange}
      aria-label={t('language.label')}
      sx={{ '& .MuiToggleButton-root': { px: 1.25, py: 0.5, fontSize: '0.75rem', fontWeight: 600 } }}
    >
      {LANGUAGES.map((language) => (
        <ToggleButton key={language} value={language} aria-label={t(`language.${language}`)} lang={language}>
          {language.toUpperCase()}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default LanguageSwitcher;
